import {
    DtoExport,
    DtoForceConstructor,
    DtoImport,
} from '../../utils/dto';
import { Dto } from '../../data/dto/dto';
import { DTO_DEFAULT, DtoType } from '../../data/dto/dto-types';
import { DeliveryOrderConfigSchema } from './delivery-order-config-schema';
import { DispatchMode } from './dispatch-mode';

@DtoForceConstructor
export class DeliveryOrderConfig {
    id: string;
    active: boolean;
    pickupPrepTime: number;
    latePickupNotificationMins: number;
    lateDropoffNotificationMins: number;
    locationCode: string;
    pickupNotes: string;
    deliverableAction: string;
    undeliverableAction: string;
    dispatchMode: DispatchMode;
    defaultItemSize: string;
    defaultCustomerName: string;
    serviceProviders: string[];
    defaultRequiresId: boolean;
    requiresIdKeywords: string[];

    @DtoImport(DeliveryOrderConfigSchema)
    static import(dto: Dto): any {}

    constructor(value?: {
        id?: string;
        active: boolean;
        pickupPrepTime: number;
        latePickupNotificationMins: number;
        lateDropoffNotificationMins: number;
        locationCode: string;
        pickupNotes: string;
        deliverableAction: string;
        undeliverableAction: string;
        dispatchMode: DispatchMode;
        defaultItemSize: string;
        defaultCustomerName: string;
        serviceProviders: string[];
        defaultRequiresId: boolean;
        requiresIdKeywords: string[];
    }) {
        if (value) {
            this.id = value.id;
            this.active = value.active;
            this.pickupPrepTime = value.pickupPrepTime;
            this.latePickupNotificationMins = value.latePickupNotificationMins;
            this.lateDropoffNotificationMins =
                value.lateDropoffNotificationMins;
            this.locationCode = value.locationCode;
            this.pickupNotes = value.pickupNotes;
            this.deliverableAction = value.deliverableAction;
            this.undeliverableAction = value.undeliverableAction;
            this.dispatchMode = value.dispatchMode;
            this.defaultItemSize = value.defaultItemSize;
            this.defaultCustomerName = value.defaultCustomerName;
            this.serviceProviders = value.serviceProviders;
            this.defaultRequiresId = value.defaultRequiresId;
            this.requiresIdKeywords = value.requiresIdKeywords;
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DeliveryOrderConfigSchema,
        },
    ])
    export(type?: DtoType): any {}
}
